import React from "react";

import { Button, notification } from "antd";
import { Link, useNavigate } from "react-router-dom";
import { useUnlockAccountMutation } from "store/api";

import { Formik } from "formik";
import * as Yup from "yup";
import InputField from "components/Common/InputField";
import { ErrorAlert } from "components/Common";
// import { maskEmail } from "utils";

const UnlockAccount: React.FC = () => {
  const navigate = useNavigate();
  // const location = useLocation();
  const [error, setError] = React.useState<string | null>(null);

  const [unlockAccount, { isLoading }] = useUnlockAccountMutation();

  return (
    <div className="w-full h-full flex items-center justify-center">
      <div className="w-full h-full flex flex-col justify-center">
        <div>
          <h1 className="text-2xl font-bold mb-4">Unlock Account</h1>
          <p className="mb-4">
            {" "}
            You're almost done! Provide your account number{" "}
            {/* <strong> {maskEmail(location?.state?.email)}</strong> */}
          </p>
        </div>

        <Formik
          validateOnBlur
          initialValues={{
            account: "",
          }}
          validationSchema={Yup.object().shape({
            account: Yup.string().required("Account number is required"),
          })}
          onSubmit={async (values) => {
            try {
              await unlockAccount(values).unwrap();
              notification.success({
                message: "Account Unlocked",
                description: "You account has been unlocked successfully",
              });

              navigate("/");
            } catch (error: any) {
              setError(error?.data?.error);
            }
          }}
        >
          {({ handleSubmit, isValid, dirty }) => (
            <form onSubmit={handleSubmit} className="space-y-3">
              <ErrorAlert type="error" message={error} setMessage={setError} />
              <InputField
                label="Account Number"
                name="account"
                type="text"
                placeholder="Enter Account Number"
              />

              <Button
                type="primary"
                htmlType="submit"
                className="w-full h-10"
                loading={isLoading}
                disabled={!isValid || !dirty || isLoading}
              >
                Confirm Account Number
              </Button>
              <div className="flex items-center justify-end p-3 gap-2">
                <Link to="/" className="text-blue-500">
                  Back to login
                </Link>
              </div>
            </form>
          )}
        </Formik>
      </div>
    </div>
  );
};

export default UnlockAccount;
